
import React from "react";
import {
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import DeleteIcon from "@mui/icons-material/Delete";

const InvoiceHeader = ({
  documentType,
  invoice,
  isDisabled,
  setOpenModal,
  setAnchorEl,
  anchorEl,
  handleOpenDeleteModal,
  handleOpenConvertModal,
  navigate,
}) => {
  return (
    <div className="d-flex justify-content-end align-items-center mb-2">
      {documentType !== "Estimate" && (
        <button
          className="btn btn-success me-2"
          onClick={() => setOpenModal(true)}
        >
          <i className="fas fa-money-check-alt me-1"></i> Record Payment
        </button>
      )}
      <IconButton
        aria-label="more"
        aria-controls="action-menu"
        aria-haspopup="true"
        onClick={(event) => setAnchorEl(event.currentTarget)}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="action-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        <MenuItem
          onClick={() => handleOpenDeleteModal()}
          style={{ color: "red" }}
        >
          <ListItemIcon>
            <DeleteIcon fontSize="small" className="me-2" />
          </ListItemIcon>
          Delete Invoice
        </MenuItem>
        {documentType === "Estimate" && (
          <MenuItem
            onClick={() => handleOpenConvertModal(invoice._id)}
            style={{ color: "blue" }}
            disabled={isDisabled}
          >
            Convert to Invoice
          </MenuItem>
        )}
        {invoice?.type && invoice.type !== "Order-Based" && (
          <MenuItem
            onClick={() => navigate(`/invoice-edit/${invoice._id}`)}
            style={{ color: "blue" }}
            disabled={isDisabled}
          >
            Edit Products
          </MenuItem>
        )}
      </Menu>
    </div>
  );
};

export default InvoiceHeader;